import React from 'react'

import FormSelect from "../../../components/atoms/Select";
import {
    handleFind,
} from "../../../helper/utils";
import PageTable from "../../../components/pageComponents/PageTable";
import ActionsIcons from "../../../components/atoms/ActionsIcons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DetalleFlujoDocumentoEmpleado from "./modales/DetalleFlujoDocumentoEmpleado";
import ReasignarResponsable from "./modales/ReasignarResponsable";
import EliminarFlujoDocumentoEmpleado from "./modales/EliminarFlujoDocumentoEmpleado";
import ResetearFlujoDocumentoEmpleado from "./modales/ResetearFlujoDocumentoEmpleado";

const AdminTableFlujoDocumentoEmpleado = ({
                                         formValues,
                                         setFormValues,
                                         setModalEnabled,
                                         paginator,
                                         setPaginator,
                                         keys: KEYS,
                                         manageSearch,
                                         fromAdminPage
                                     }) => {
    const rows = formValues.Items;

    const HEADERS = [
        {col: "col-sm-1", label: "Fecha de Registro"},
        {col: "col-sm-2", label: "Nombre"},
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsSedes)}
                        description="Sede"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsSedes] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsSedes)}
                    />
                </div>
        },
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsAreas)}
                        description="Área"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsAreas] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsAreas)}
                    />
                </div>
        },

        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsCargos)}
                        description="Cargo"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsCargos] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsCargos)}
                    />
                </div>
        },
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsEstados)}
                        description="Estado"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsEstados] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsEstados)}
                    />
                </div>
        },
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsPasos)}
                        description="Paso"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsPasos] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsPasos)}
                    />
                </div>
        },
        {col: "col-sm-1", label: "Responsable"},
        {col: "col-sm-1", label: "Acciones"},
    ]

    const handleFilterSelected = (res, key) => {
        const updatedSelectedFilters = {...formValues.selectedFilters, [key]: res};
        setFormValues(lastData => ({...lastData, selectedFilters: updatedSelectedFilters}));
    }

    return (
        <PageTable headers={HEADERS} paginator={paginator} setPaginator={setPaginator}>
            <tbody className="listar-tbody">
            {rows.map((row, i) => (
                <tr key={i}>
                    <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center">
                            {row.FechaRegistro}
                        </div>
                    </td>
                    <td className="text-center">{row?.NombreEmpleado}</td>
                    <td className="text-center">{row?.Sede}</td>
                    <td className="text-center">{row?.Area}</td>
                    <td className="text-center">{row?.Cargo}</td>
                    <td className="text-center">{row?.EstadoPaso}</td>
                    <td className="text-center">{row?.Paso}</td>
                    <td className="text-center">{row?.ResponsablePaso}</td>
                    <td className="text-center">
                        <ActionsIcons>
                            <FontAwesomeIcon
                                icon="id-card"
                                title="Ver Detalle"
                                size="lg"
                                onClick={(e) => {
                                    if (e)
                                        e.preventDefault();
                                    setModalEnabled({
                                        isEnable: true,
                                        component: DetalleFlujoDocumentoEmpleado,
                                        data: {row, fromAdminPage: fromAdminPage, manageSearch},
                                    })
                                }
                                }
                            />

                            {row?.PuedeReasignar === true &&
                                <FontAwesomeIcon
                                    icon="male"
                                    title="Reasignar Responsable"
                                    size="lg"
                                    onClick={() =>
                                        setModalEnabled({
                                            isEnable: true,
                                            component: ReasignarResponsable,
                                            data: {
                                                idFlujoDocumentoEmpleado : row.IdFlujoDocumentoEmpleado,
                                                nombreEmpleado: row.NombreEmpleado,
                                                nombreEmpleadoResponsable: row.ResponsablePaso,
                                                refreshPage: manageSearch
                                            },
                                        })
                                    }
                                />
                            }

                            {row?.PuedeEliminar === true &&
                                <FontAwesomeIcon
                                    icon="trash"
                                    title="Eliminar"
                                    size="sm"
                                    onClick={() =>
                                        setModalEnabled({
                                            isEnable: true,
                                            component: EliminarFlujoDocumentoEmpleado,
                                            data: {
                                                idFlujoDocumentoEmpleado : row.IdFlujoDocumentoEmpleado,
                                                refreshPage: manageSearch
                                            },
                                        })
                                    }
                                />
                            }

                            {row?.PuedeResetear === true &&
                                <FontAwesomeIcon
                                    icon="undo-alt"
                                    title="Resetear"
                                    size="sm"
                                    onClick={() =>
                                        setModalEnabled({
                                            isEnable: true,
                                            component: ResetearFlujoDocumentoEmpleado,
                                            data: {
                                                idFlujoDocumentoEmpleado : row.IdFlujoDocumentoEmpleado,
                                                refreshPage: manageSearch
                                            },
                                        })
                                    }
                                />
                            }

                        </ActionsIcons>
                    </td>
                </tr>
            ))}
            </tbody>
        </PageTable>
    );
}

export default AdminTableFlujoDocumentoEmpleado;
